module.exports = __webpack_public_path__ + "static/media/stay-organized.0b6ed872.svg";